<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      ico:'',
      pc_domain:''
    }
  },
  components: {
   
  },
  methods:{
    getConfig(){
      this.$axios.post(this.api.index.index,{},res =>{
          this.ico=res.data.logo;
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = this.ico;
          document.getElementsByTagName('head')[0].appendChild(link);
          this.$store.dispatch('setGroupLogo',res.data.group_logo);
          this.pc_domain=res.data.pc_domain;
          var pcflag=this.IsPC();
          if(pcflag){
            var pc_path='http://'+this.pc_domain+this.$route.fullPath;
            window.location.href=pc_path;
          } 
      }); 
    },
    IsPC(){  
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");  
      var flag = true;  
      for (var v = 0; v < Agents.length; v++) {  
        if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }  
      }  
      return flag;  
    }
  },
  mounted() {
    this.getConfig();
  },
}
</script>

<style>
html,body{height:100%;background:#F2F3F5;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height:100%;
  position:relative;
}
.app{min-height:100vh;}
</style>



// WEBPACK FOOTER //
// src/App.vue